// removed by extract-text-webpack-plugin
module.exports = {"choice":"choice___2_Z7T","backer":"backer___nyFfS","select":"select___1fM6a","label":"label___3J82u"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/EditVariable/RoundEditor/styles.scss
// module id = 433
// module chunks = 0